var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKleeblattThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.55 56.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.56,13a13.78,13.78,0,0,0-7.91,2.89A13.78,13.78,0,0,0,27.5,8c0-4.71-3-8-7.23-8s-7.22,3.28-7.22,8a13.72,13.72,0,0,0,2.85,7.85A13.84,13.84,0,0,0,8,13c-4.71,0-8,3-8,7.22S3.28,27.4,8,27.4c6.49,0,11.53-6.16,11.79-6.42l.1-.1a17.08,17.08,0,0,0-.48,3.87l-.13,4.57L19,38.47l-.15,9.14c0,3-.06,6.1,0,9.15h2.91c0-3,0-6.1,0-9.15l-.15-9.14-.26-9.15-.13-4.57a17.08,17.08,0,0,0-.48-3.87l.1.1c.26.26,5.31,6.42,11.79,6.42,4.71,0,8-3,8-7.22S37.27,13,32.56,13ZM15.31,8c0-2.86,1.53-5.73,5-5.73s5,2.87,5,5.73c0,4.27-3.38,10-5,11.88C18.69,18.05,15.31,12.27,15.31,8ZM8,25.15c-2.86,0-5.73-1.54-5.73-5s2.87-5,5.73-5c4.27,0,10,3.39,11.88,5C18.05,21.76,12.27,25.15,8,25.15Zm24.57,0c-4.27,0-10-3.39-11.88-5,1.83-1.58,7.6-5,11.88-5,2.86,0,5.74,1.54,5.74,5S35.42,25.15,32.56,25.15Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKleeblattThin);
export default __webpack_public_path__ + "static/media/Kleeblatt_thin.efd0238a7fcdbc1c2542540f84caa2bd.svg";
export { ForwardRef as ReactComponent };